;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import { graphRequest } from 'services/contentful';

import {
    assetFragment,
    ctaFragment,
    linkFragment,
} from 'lib/graphql/fragments';

import BlockSubCategoryIntro from './BlockSubCategoryIntro';

const query = /* GraphQL */ `
    ${assetFragment}
    ${linkFragment}
    ${ctaFragment}
    query getBlock($id: String!, $preview: Boolean!) {
        blockSubCategoryIntro(preview: $preview, id: $id) {
            __typename
            anchorId
            backgroundColor
            headline
            description
            cta {
                ...CTA
            }
            imageDesktop {
                ...Asset
            }
            imageMobile {
                ...Asset
            }
            backLink {
                slug
                navLabel
                title
            }
        }
    }
`;

async function fetchBlock(id) {
    const {
        body: {
            data: { blockSubCategoryIntro },
        },
    } = await graphRequest({
        query,
        variables: { id },
    });

    return blockSubCategoryIntro;
}

const BlockSubCategoryIntroServer = async ({ id }) => {
    const block = await fetchBlock(id);

    return <BlockSubCategoryIntro {...block} />;
};

export default BlockSubCategoryIntroServer;
